import PageHeader from "./blocks/headers/PageHeader.vue";
import BaseLayout from "./base/BaseLayout.vue";
import BaseInput from "./base/BaseInput.vue";
import BaseForm from "./base/BaseForm.vue";
import BaseToggle from "./base/BaseToggle.vue";
import Choose from "./blocks/Choose.vue";

export default [
  PageHeader,
  BaseLayout,
  BaseInput,
  BaseForm,
  BaseToggle,
  Choose,
];
